import React from "react";
import { Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./component/LanguageContext";
import AppLayout from "./component/AppLayout";
import { appRoutes } from "./config/appRoutes";


function App() {
  return (
    <LanguageProvider>
      <Routes>
        <Route element={<AppLayout />}>
          {appRoutes.map(({ path, Page }) => (
            <Route key={path} path={path} element={<Page />} />
          ))}
        </Route>
      </Routes>
    </LanguageProvider>
  );
}

export default App;
